import request from '../../../../api/request';
import { StudentDocumentsResponse } from '../parts/studentDocuments/types';

const STUDENT_DOCUMENTS = {
  GET_STUDENT_DOCUMENTS: (studentId: string | number) =>
    `teacher-portal/student-file/student-documents/${studentId}`,
  GET_STUDENT_DOCUMENTS_DOWNLOAD: (
    studentId: string | number,
    studentDocumentId: number,
  ) =>
    `teacher-portal/student-file/student-documents/${studentId}/student-document/${studentDocumentId}/download`,
  GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD: (
    studentId: string | number,
  ) =>
    `teacher-portal/student-file/student-documents/${studentId}/tuition-documents/download`,
};

export function getStudentDocuments(studentId: number) {
  return request<StudentDocumentsResponse>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS(studentId),
  );
}

export function getStudentDocumentsTuitionDocumentDownload(
  studentId: number,
  params: { type: string; documentId: number | string },
) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD(
      studentId,
    ),
    {
      params,
    },
  );
}

export function getStudentDocumentsTuitionDocumentView(
  studentId: number,
  params: { type: string; documentId: number | string },
) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_TUITION_DOCUMENTS_DOWNLOAD(
      studentId,
    ),
    {
      params: { ...params, inline: true },
    },
  );
}

export function getStudentDocumentDownload({
  studentId,
  studentDocumentId,
}: {
  studentId: number;
  studentDocumentId: number;
}) {
  return request<{ url: string }>(
    STUDENT_DOCUMENTS.GET_STUDENT_DOCUMENTS_DOWNLOAD(
      studentId,
      studentDocumentId,
    ),
  );
}
